import {useState, useEffect} from 'react'
import {
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    Input,
    Card,
    CardBody,
    Button
} from 'reactstrap'
import {Link} from 'react-router-dom'
import classnames from 'classnames'
import {PropTypes} from "prop-types"

const Search = (props) => {
    const {searchValue, handleReset, handleSearch} = props
    const [searchInputValue, setSearchInputValue] = useState('')
    const [activePage, setActivePage] = useState('All')

    useEffect(() => {
        setSearchInputValue(searchValue)
    }, [searchValue])

    const handeSearchProfiles = () => {
        handleSearch(searchInputValue)
    }

    const handeResetSearch = () => {
        setSearchInputValue('')
        handleReset()
    }

    const onEnterSearch = (e) => {
        if (e.key === 'Enter') {
            handeSearchProfiles()
        }
    }

    return (
        <Card className="mt-2">
            <CardBody className="">
                <Row>
                    <Col md="6">
                        <InputGroup size='lg' className="input-group-with-tabs-c">
                            <InputGroupAddon addonType='append'>
                                <Button
                                    className={classnames({
                                        'active-tab': activePage === 'All'
                                    })}
                                    onClick={() => setActivePage('All')}
                                    tag={Link}
                                    to={'/dashboard/rd/brands'}
                                    color='primary'
                                    outline>
                                    All
                                </Button>
                            </InputGroupAddon>
                            <InputGroupAddon addonType='append'>
                                <Button
                                    className={classnames({
                                        'active-tab': activePage === 'My Brands'
                                    })}
                                    onClick={() => setActivePage('My Brands')}
                                    tag={Link}
                                    to={'/dashboard/rd/my-brands'}
                                    color='primary' outline>
                                    My Brands
                                </Button>
                            </InputGroupAddon>
                            <InputGroupAddon addonType='append'>
                                <Button
                                    className={classnames({
                                        'active-tab': activePage === 'Favorites'
                                    })}
                                    onClick={() => setActivePage('Favorites')}
                                    tag={Link}
                                    to={'/dashboard/rd/favorite-folders'}
                                    color='primary'
                                    outline>
                                    Favorites
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                    </Col>
                    <Col md="6">
                        <InputGroup size='lg' className="mt-2 mt-md-0">
                            <Input placeholder='Search By Name' value={searchInputValue} onChange={e => setSearchInputValue(e.target.value)} onKeyDown={onEnterSearch}/>
                            <InputGroupAddon addonType='append'>
                                <Button color='primary' onClick={handeSearchProfiles} outline>
                                    Search
                                </Button>
                            </InputGroupAddon>
                            <InputGroupAddon addonType='append'>
                                <Button color='primary' onClick={handeResetSearch} outline>
                                    Reset
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

Search.propTypes = {
    searchValue: PropTypes.string.isRequired,
    handleReset: PropTypes.func.isRequired,
    handleSearch: PropTypes.func.isRequired
}

export default Search
